import { AppLogo } from '../branding/AppLogo';

type SidebarBrandProps = {
  collapsed?: boolean;
};

export function SidebarBrand({ collapsed = false }: SidebarBrandProps) {
  if (collapsed) {
    return (
      <div className="shrink-0 border-b border-white/15 px-2 py-2">
        <div className="mx-auto flex h-10 w-10 items-center justify-center overflow-hidden rounded-lg border border-white/20 bg-white shadow-sm">
          <AppLogo variant="icon" className="h-7 w-7 object-contain" />
        </div>
      </div>
    );
  }

  return (
    <div className="shrink-0 border-b border-white/15 px-2 py-2">
      <div className="overflow-hidden rounded-lg border border-white/20 bg-white px-1 py-1 shadow-sm">
        <AppLogo className="mx-auto block h-16 w-full max-w-none object-contain object-center" />
      </div>
    </div>
  );
}
